import CSVColumnsStrategy from '../CSVColumnsStrategy'

export default function BillingSummaryCSVPreviewColumnsStrategy() {}
BillingSummaryCSVPreviewColumnsStrategy.prototype = new CSVColumnsStrategy();
BillingSummaryCSVPreviewColumnsStrategy.prototype.init = function ()
{
    CSVColumnsStrategy.prototype.init.call( this );
    return this;
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.getNumOfDataColumns = function ()
{
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addDataCells = function ( row )
{
    for( var i = 0; i < this.getNumOfDataColumns(); i++ )
        this.addTimeValueCell( row );
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addEmptyCells = function ( row )
{
    ReportPreviewUtils.addEmptyCells( row, this.getNumOfDataColumns() );
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addBillingTypeCells = function ( row, numOfCells )
{
    for( var i = 0; i < numOfCells; i++ )
        this.addBillingTypeCell( row );
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addBillingTypeCell = function ( row )
{
    this.addCell( row, this.message("report.billing_type") );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewColumnsStrategy.js